import React, { Component } from "react";
import {
  withStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Axios from "axios";

import Visibility from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";

import { useStyles } from "./AdminLogin.css";
import { url } from "../../../Config/Config";
import { connect } from "react-redux";
import { adminLogin } from "../../../Redux/Actions/actions";
import FormLoader from "../../../Components/FormLoader/FormLoader";

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#184e98",
    },
  },
});

class AdminLogin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        username: "",
        password: "",
      },
      usernameError: "",
      passwordError: "",
      showPassword: false,
      loading: false,
    };
  }

  handleChange = (e) => {
    this.setState({
      data: {
        ...this.state.data,
        [e.target.name]: e.target.value,
      },
    });
  };

  showPassword = () => {
    return (
      <Visibility
        style={{ cursor: "pointer" }}
        onClick={() => this.setState({ showPassword: true })}
      />
    );
  };

  hidePassword = () => {
    return (
      <VisibilityOffIcon
        style={{ cursor: "pointer" }}
        onClick={() => this.setState({ showPassword: false })}
      />
    );
  };

  checkError = (username, password) => {
    let usernameError = username ? username : "";
    let passwordError = password ? password : "";

    if (this.state.data.username.length < 5) {
      usernameError = "Username must be minimum of 5 characters.";
    }

    if (this.state.data.password.length < 8) {
      passwordError = "Password must be minimum of 8 characters";
    }

    if (usernameError || passwordError) {
      this.setState({
        usernameError,
        passwordError,
      });
      return true;
    } else {
      this.setState({
        usernameError: "",
        passwordError: "",
      });
      return false;
    }
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    let errorStatus = this.checkError();
    if (errorStatus === false) {
      try {
        this.setState({ loading: true });
        const response = await Axios.post(
          `${url}/api/admin/login`,
          this.state.data
        );
        if (response.data.accessToken && response.data.refreshToken) {
          this.props.adminLogin(
            response.data.accessToken,
            response.data.refreshToken,
            response.data.role
          );
        }
      } catch (error) {
        this.setState({ loading: false });
        if (
          error.response.status === 404 &&
          error.response.data.message === "Invalid email/password"
        ) {
          console.clear();
          this.checkError("Invalid Username", "");
        }

        if (
          error.response.status === 401 &&
          error.response.data.message === "Invalid email/password"
        ) {
          console.clear();
          this.checkError("", "Invalid Password");
        }
      }
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <div style={{ fontSize: 24, fontWeight: "bold" }}>ADMIN</div>
        <h1>School Management System</h1>
        <form onSubmit={this.handleSubmit}>
          <TextField
            name="username"
            type="username"
            label="Username"
            fullWidth
            required
            margin="normal"
            variant="outlined"
            placeholder="Enter username provided"
            style={{ outline: "none" }}
            error={this.state.usernameError ? true : false}
            helperText={this.state.usernameError}
            InputProps={{
              classes: {
                root: classes.inputRoot,
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={this.state.data.username}
            onChange={this.handleChange}
          />
          <TextField
            name="password"
            type={this.state.showPassword ? "text" : "password"}
            label="Password"
            fullWidth
            required
            margin="normal"
            variant="outlined"
            placeholder="Enter password provided"
            style={{ outline: "none" }}
            error={this.state.passwordError ? true : false}
            helperText={this.state.passwordError}
            InputProps={{
              classes: {
                root: classes.inputRoot,
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
              endAdornment: this.state.showPassword
                ? this.hidePassword()
                : this.showPassword(),
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={this.state.data.password}
            onChange={this.handleChange}
          />

          <div style={{ display: "flex", alignItems: "center" }}>
            <ThemeProvider theme={theme}>
              <Button
                aria-label="Submit"
                type="submit"
                variant="outlined"
                color="primary"
                className={classes.buttonStyle}
              >
                Login
              </Button>
            </ThemeProvider>
            {this.state.loading && <FormLoader />}
          </div>
        </form>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    adminLogin: (token, refreshToken, role) => {
      dispatch(adminLogin(token, refreshToken, role));
    },
  };
};

export default connect(
  null,
  mapDispatchToProps
)(withStyles(useStyles)(AdminLogin));
